import styled from 'styled-components';
import { Button } from '@/ui';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    margin: 1rem 0;
    height: 2.5rem;
    border-radius: 2rem;

    @media screen and ${DEVICES.LAPTOP_S} {
      margin-bottom: 1.5rem;
    }
  }
`;

export const StyledForgotPassword = styled.div`
  ${pickThemeFontStyles('16', '20', 'NORMAL')};
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 1.5rem;
`;

export const StyledCopyButton = styled(Button)`
  &&& {
    font-size: inherit;
    padding: 0;
    background-color: ${COLORS.WHITE};
    color: ${COLORS.ORANGE_PRIMARY};
    line-height: inherit;
    height: auto;
  }
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  margin-bottom: 0.5rem;
  text-align: center;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('40', '48', 'SEMI_BOLD')};
    margin-bottom: 1rem;
  }
`;

export const StyledDescription = styled.div`
  ${pickThemeFontStyles('12', '14', 'SEMI_BOLD')};
  margin-bottom: 0.5rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('18', '24', 'SEMI_BOLD')};
    margin-bottom: 1rem;
  }
`;

export const StyledQRCode = styled.img`
  width: 100%;

  margin-bottom: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    margin-bottom: 2rem;
  }
`;
